// extracted by mini-css-extract-plugin
export default {"inputNumber":"CostInput_inputNumber__it2-5"};